<template>
  <div v-if="valid" class="size-chart-preview">
    <el-popover
      placement="right-start"
      trigger="hover"
      :open-delay="120"
      :width="560"
      popper-class="doudian-size-chart-popper"
      :append-to-body="true"
    >
      <div class="size-chart-preview__large" tabindex="0" aria-label="尺码表放大预览">
        <strong>{{ chart.title || '商品尺码表' }}</strong>
        <p>{{ chart.desc }}</p>
        <table>
          <thead>
            <tr>
              <th>尺码</th>
              <th v-for="spec in chart.selectedSpecs" :key="spec">
                {{ spec }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in chart.configTable" :key="String(row.size)">
              <td>{{ row.size }}</td>
              <td v-for="spec in chart.selectedSpecs" :key="spec">
                {{ row.specMap && row.specMap[spec] != null ? row.specMap[spec] : '—' }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <button
        slot="reference"
        type="button"
        class="size-chart-preview__card"
        aria-label="查看尺码表，点击放大"
        @click="visible = true"
      >
        <div class="size-chart-preview__mini" aria-hidden="true">
          <strong>{{ chart.title || '商品尺码表' }}</strong>
          <p>{{ chart.desc }}</p>
          <table>
            <thead>
              <tr>
                <th>尺码</th>
                <th v-for="spec in chart.selectedSpecs" :key="spec">
                  {{ spec }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in chart.configTable.slice(0, 8)" :key="String(row.size)">
                <td>{{ row.size }}</td>
                <td v-for="spec in chart.selectedSpecs" :key="spec">
                  {{ row.specMap && row.specMap[spec] != null ? row.specMap[spec] : '—' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <span>悬浮或点击放大</span>
      </button>
    </el-popover>
    <el-dialog title="尺码表预览" :visible.sync="visible" append-to-body width="min(90vw, 760px)">
      <div class="size-chart-preview__large">
        <strong>{{ chart.title || '商品尺码表' }}</strong>
        <p>{{ chart.desc }}</p>
        <table>
          <thead>
            <tr>
              <th>尺码</th>
              <th v-for="spec in chart.selectedSpecs" :key="spec">
                {{ spec }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in chart.configTable" :key="String(row.size)">
              <td>{{ row.size }}</td>
              <td v-for="spec in chart.selectedSpecs" :key="spec">
                {{ row.specMap && row.specMap[spec] != null ? row.specMap[spec] : '—' }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </el-dialog>
  </div>
  <span v-else class="size-chart-preview__empty">{{ emptyText }}</span>
</template>

<script>
export default {
  name: 'DoudianSizeChartPreview',
  props: {
    chart: { type: Object, default: null },
    emptyText: { type: String, default: '执行时读取尺码表' }
  },
  data: () => ({ visible: false }),
  computed: {
    valid() {
      return this.chart && Array.isArray(this.chart.selectedSpecs) && Array.isArray(this.chart.configTable)
    }
  }
}
</script>

<style scoped>
.size-chart-preview__card {
  position: relative;
  width: 150px;
  height: 104px;
  overflow: hidden;
  padding: 6px;
  background: white;
  border: 1px solid #e2e7ef;
  border-radius: 4px;
  cursor: zoom-in;
}
.size-chart-preview__card > span {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background: #ffffffed;
  color: #6a7485;
  font-size: 10px;
  line-height: 18px;
}
.size-chart-preview__mini {
  width: 500px;
  transform: scale(0.27);
  transform-origin: top left;
  font-size: 13px;
  pointer-events: none;
}
.size-chart-preview__large {
  max-height: 65vh;
  max-width: 100%;
  overflow: auto;
  font-size: 12px;
  text-align: center;
}
table {
  width: 100%;
  border-collapse: collapse;
  white-space: nowrap;
}
th {
  background: #111;
  color: #fff;
}
th,
td {
  padding: 6px 10px;
  border: 1px solid #e8e8e8;
}
tbody tr:nth-child(even) {
  background: #eee;
}
p {
  color: #777;
  font-size: 11px;
  margin: 8px;
}
.size-chart-preview__empty {
  font-size: 11px;
  color: #8b94a2;
}
</style>

<style>
.doudian-size-chart-popper {
  max-width: calc(100vw - 36px);
  box-sizing: border-box;
}
</style>
